import Rules from './rules.js'

export default {
  install (Vue, options) {
    Vue.use(Rules, {
      errorBagName: 'vErrors'
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/validator/index.js